import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Controller, useWatch, useController } from 'react-hook-form';
import { Box } from '@mui/material';

import Input from './Input';
import AttachmentLinksList from '../../../Shared/AttachmentLinksList';
import { useNotifications } from '@toolpad/core/useNotifications';
import { notify } from '../../../../../Utils/NotificationUtils';

function Attachments({
  name = 'attachments',
  control,
  errors,
  setError,
  setDisabledForm,
  required = false,
  noTitle = false,
  disabled,
  inputProps = {},
}: any) {
  const intl = useIntl();
  const notifications = useNotifications();

  // NOTE: This is a work around, because react-hook-form does not render the value that we get from the api
  // when we useWatch() the value is there
  // but the value from Controller is empty
  const attachmentsState = useWatch({
    control,
    name,
  });
  const { field } = useController({
    control,
    name,
  });

  useEffect(() => {
    if (attachmentsState?.length && !field.value?.length) {
      field.onChange(attachmentsState);
    }
  }, [attachmentsState, field]);

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        validate: (value: any) => {
          if (!value) {
            return true;
          }
          const infected = value?.some((item: any) => item.virus_scan_status === 'infected');
          if (infected) {
            notify(
              notifications,
              intl.formatMessage({ id: 'VIRUS_SCAN.INFECTED_ATTACHMENTS_ERROR' }),
              'error',
            );
          }

          return !infected;
        },
      }}
      render={({ field: { onChange, value = [] } }: any) => {
        if (disabled && value.length > 0) {
          return (
            <Box sx={{ my: -3 }}>
              <AttachmentLinksList attachments={value} />
            </Box>
          );
        }

        return (
          <Input
            name={name}
            onChange={onChange}
            value={value}
            errors={errors}
            setDisabledForm={setDisabledForm}
            setError={setError}
            required={required}
            noTitle={noTitle}
            inputProps={inputProps}
          />
        );
      }}
    />
  );
}

export default Attachments;
